import React from 'react'
import { connect } from 'react-redux'
import { changeItemsValue, getFormValue, getListFromValues } from 'tyan/public/utility'

class SelectExportDiv extends React.Component {
    state = {
    }

    EventNames = {
        '月薪记录表': 'ExportSalary',
        '薪资汇总表': 'ExportSalarySummary',
        '社保、医保汇总表': 'ExportSocialSecurityAndMedicalInsuranceSummary',
        '住房公积金汇总表': 'ExportHousingFundSummary',
    }

    componentDidMount = () => {
    }

    handlerConfirm = () => {
        const { id, onClose } = this.props
        let title = getFormValue(this, '基本信息', '导出模板')
        const EventName = this.EventNames[title]
        Tyan.pubForm.showExport({ event: EventName, eventData: { id }, title: title })
        onClose && onClose()
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }


    canSave = () => {
        return this.bChanged() && getFormValue(this, '基本信息', '导出模板')
    }

    bChanged = () => {
        return Tyan.utility.hasChangedValues(this)
    }


    fieldset基本信息 = () => {
        return [
            { _radio: '', name: '导出模板', required: true, itemMinWidth: 100, items: ['月薪记录表', '薪资汇总表', '社保、医保汇总表', '住房公积金汇总表'] },
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body } = this.props

        return <Body data={this} maxWidth="900"
            controls={
                [
                    { _button: '确定', icon: 'save', handler: this.handlerConfirm, disabled: !this.canSave() },
                    { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                ]}

            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息() },
                ]
            }
        />
    }
}

export default connect()(SelectExportDiv)